import React, { useEffect, useRef } from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

function useOutsideAlerter(ref, closeNavBar, windowWidth) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && ref.current.contains(event.target) && !windowWidth) {
        // alert('You clicked outside of me!');
        closeNavBar();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export default function CustomNavLink({ children, to, closeNavBar, ...props }) {
  const wrapperRef = useRef(null);
  const windowWidth = window.innerWidth;
  useOutsideAlerter(wrapperRef, closeNavBar, windowWidth >= 992);
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });
  return (
    <Link
      ref={wrapperRef}
      to={to}
      class={match ? 'nav-link active' : 'nav-link '}
      style={{ fontSize: '16px' }}
      {...props}
    >
      {children}
    </Link>
  );
}
